import type * as React from 'react';

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <main className='w-full min-w-0 max-w-full overflow-x-clip'>
      <div className='mx-auto w-full min-w-0 max-w-[1600px] px-4 pb-8 md:px-6'>
        {children}
      </div>
    </main>
  );
}
